<nav
  id="main-prod-header"
  class="navbar navbar-default whitebar"
  style="background-color: #eee"
>
  <div class="container dashboard">
    <div class="navbar-header row d-flex justify-content-center">
      <div class="col-md-3">
        <a href="https://mapport.com/">
          <img
            class="logo-img img-responsive"
            id="logo_placeholder"
            src="/assets/img/MapPort-Logo.png"
          />
        </a>
      </div>
      <ul id="dashboard-ul">
        <li class="list-deco">
          <div class="dropdown">
            <a class="list-deco" id="user-button"
              >{{ firstName }} {{ lastName }}</a
            >
            <div class="dropdown-content">
              <a id="myProfile" routerLink="/profile">My Profile</a>
              <a id="logout" (click)="logOut()">Log out</a>
            </div>
          </div>
        </li>
        <li class="list-deco">
          <div class="dropdown">
            <a class="list-deco support">SUPPORT</a>
            <div class="dropdown-content support">
              <a id="map-product-text">Which MapPort product?</a>

              <!-- commented as per client modification -->
              <!-- <a
                href="https://wildfiredamageviewer.mapport.com/support/"
                target="_blank"
                >Wildfire Damage Viewer</a
              > -->
              <a
                href="https://wildfireviewer.mapport.com/support/"
                target="_blank"
                >Wildfire Viewer</a
              >
              <a
                href="https://parcelviewer.mapport.com/support/"
                target="_blank"
                >Parcel Viewer</a
              >
            </div>
          </div>
        </li>
        <li class="list-deco">
          <div class="dropdown">
            <a class="list-deco menu-button-subscribe get_maps"
              >GET MAPS &amp; ADD-ONS</a
            >
            <div class="dropdown-content">
              <a id="map-product-text">Which MapPort product?</a>
              <a href="/parcelviewer/subscribe/" class="dropdown-products"
                >Parcel Viewer</a
              >
              <a href="/wildfireviewer/subscribe/" class="dropdown-products"
                >Wildfire Viewer</a
              >
              <!-- commented as per client modification -->
              <!-- <a
                href="/wildfiredamageviewer/subscribe/"
                class="dropdown-products"
                >Wildfire Damage Viewer</a
              > -->
            </div>
          </div>
        </li>
        <li id="idbacktodemigod" class="list-deco" *ngIf="showDemigod">
          <a
            (click)="backToDemigod()"
            style="cursor: pointer; color: #2c84c6"
            title="This leads to demigod dashboard."
            class="navbar-link"
            >Back To Demigod</a
          >
        </li>
      </ul>
    </div>
    <hr />
  </div>
</nav>
